<template>
  <b-modal
    class="content-description-modal"
    ref="modal"
    size="lg"
    centered
    laze
    title="Package Content Description"
    @hidden="onHide"
    :visible="false"
    no-fade
  >
    <div v-for="(line, i) in lines" :key="i" class="line">
      <div class="row">
        <b-form-group class="col-sm-3">
          <b-input
            v-model="lines[i].quantity"
            type="number"
            placeholder="Qty"
            :name="`quantity${i}`"
            v-validate="'required'"
            :state="errors.has(`quantity${i}`) ? false : null"
            @input="validate(`quantity${i}`)"
          ></b-input>
        </b-form-group>
        <div class="col-sm-6">
          <b-input
            v-model="lines[i].description"
            placeholder="Item Description"
            :name="`description${i}`"
            v-validate="'required'"
            :state="errors.has(`description${i}`) ? false : null"
            @input="validate(`description${i}`)"
          ></b-input>
        </div>
        <div class="col-sm-3">
          <b-input
            v-model="lines[i].value"
            type="number"
            placeholder="Item Value ($)"
            :name="`value${i}`"
            :state="errors.has(`value${i}`) ? false : null"
            @input="validate(`value${i}`)"
            v-validate="'required'"
          ></b-input>
        </div>
      </div>
      <div class="row">
        <b-form-group class="col-sm-3 mb-0" append="oz">
          <b-input
            v-model="lines[i].weight"
            placeholder="Item Weight (oz)"
            :name="`weight${i}`"
            :state="errors.has(`weight${i}`) ? false : null"
            @input="validate(`weight${i}`)"
            v-validate="'required|min_value:0.1'"
          ></b-input>
        </b-form-group>
        <b-form-group class="col-sm-3 mb-0" description="Origin">
          <b-form-select
            v-model="lines[i].origin"
            :options="countrySelectOptions"
            :name="`origin${i}`"
            :state="errors.has(`origin${i}`) ? false : null"
            @input="validate(`origin${i}`)"
            v-validate="'required'"
            required
          />
        </b-form-group>
        <div class="col-sm-6 text-right">
          <b-btn
            v-if="lines.length > 1"
            size="sm"
            variant="danger"
            @click="deleteLine(i)"
          >Delete item</b-btn>
          <b-btn
            v-if="i + 1 === lines.length"
            size="sm"
            variant="primary"
            @click="addLine"
          >Add line item</b-btn>
        </div>
      </div>
    </div>

    <div slot="modal-footer" class="w-100 text-right">
      <b-btn variant="primary" @click="hide()">Save and Close</b-btn>
    </div>
  </b-modal>
</template>

<style lang="scss">
.content-description-modal {
  .modal-footer {
    justify-content: center;
  }

  .line {
    + .line {
      margin-top: 15px;
      padding-top: 15px;
      border-top: 1px solid #e9ebec;
    }

    .form-text {
      text-align: center;
    }
  }
}
</style>
<script>
import LoadingSpinner from "./LoadingSpinner";
import Alerts from "./Alerts";
import CountrySelect from "./Form/CountrySelect";
import ThumbsUp from "./Icons/ThumbsUp";
import countries from "../data/countries.js";
import { mapActions } from "vuex";

export default {
  components: {
    LoadingSpinner,
    Alerts,
    ThumbsUp,
    CountrySelect
  },
  props: [],
  data() {
    return {
      lines: []
    };
  },
  computed: {
    countrySelectOptions() {
      return countries.getSelectOptions();
    }
  },
  watch: {
    lines: {
      deep: true,
      handler: function(val, oldVal) {
        val = _.map(val, item => {
          return {
            quantity: parseInt(item.quantity),
            description: item.description,
            unitPrice: parseFloat(item.value),
            unitWeight: {
              weight: parseInt(item.weight),
              unitOfMeasurement: "OZ"
            },
            originCountryCode: item.origin
          };
        });
        this.$emit("input", val);
      }
    }
  },
  created() {
    this.addLine();
  },
  mounted() {},
  methods: {
    ...mapActions(["refreshUser"]),
    validate(name = null) {
      this.$nextTick(() => {
        if (name) {
          this.$validator.validate(name);
        } else {
          this.$validator.validateAll();
        }
      });
    },

    async isValid() {
      return await this.$validator.validateAll();
    },

    show() {
      this.$refs.modal.show();
    },

    async hide() {
      const passed = await this.$validator.validateAll();

      if(passed) {
        this.$refs.modal.hide();
      }
    },

    onHide() {},

    addLine() {
      this.lines.push({
        origin: "US"
      });
    },
    deleteLine(i) {
      this.lines.splice(i, 1);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ContentDescriptionModal2.vue